export const assetTypes = ["Laptop", "Car", "Bike", "Phone", "Others"];
